import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Alert, Spinner } from 'react-bootstrap';
import espmapa from '../../../assets/esp-mapa.png';
import { getPrefix } from '../../../util/utils';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import useMapa from '../../../hooks/useMapa';

export default function EspelhoMapa() {
  const { id } = useParams();
  const { data: mapa, error, isLoading } = useMapa(id);
  const laudoMapa = mapa?.[0];

  return (
    <Card style={{ fontSize: 24, marginTop: 10, marginBottom: 10 }}>
      <LaudoCardHeader title="LAUDO DE MAPA" />

      {error && !isLoading && (
        <Alert variant="danger" style={{ marginTop: 10 }}>
          <Alert.Heading>Erro ao carregar laudo de mapa!</Alert.Heading>
          <p>Tente novamente.</p>
        </Alert>
      )}

      {isLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <Spinner animation="border" variant="dark" size="lg" />
        </div>
      )}

      {!isLoading && !error && laudoMapa && (
        <>
          <Card.Body>
            <strong className="mr-auto">Cod MAPA: </strong>
            {laudoMapa.CODMAPA}&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${laudoMapa.CODPAC} - ${laudoMapa.NOMEPAC}`}
            <br></br>
            <strong className="mr-auto">Sexo: </strong>
            {`${laudoMapa.SEXOPAC}`}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data de Nasc: </strong>
            {`${laudoMapa.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {`${laudoMapa.idadePAC} anos`}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Alt: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Peso: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">SC: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br></br>
            <strong className="mr-auto">Convênio: </strong>
            {laudoMapa.DESCRICONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {laudoMapa.dataMapa}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br></br>
            <strong className="mr-auto">
              Médico que Solicitou: {getPrefix(laudoMapa.CODSOLICITANTE)}{' '}
            </strong>
            {`${laudoMapa.Solicitou}`}
            <hr></hr>
            <div>
              <img
                width="95%"
                height="60%"
                loading="lazy"
                src={espmapa}
                alt="espelho mapa"
              />{' '}
            </div>
          </Card.Body>
          <Card.Footer id="removeMe" className="text-center">
            <Button variant="outline-primary" onClick={() => window.print()}>
              Imprimir
            </Button>
          </Card.Footer>
        </>
      )}
    </Card>
  );
}
